(function () {
  'use strict';

  if (window.__parityAnimationsInitialized) return;
  window.__parityAnimationsInitialized = true;

  function initParityAnimations() {
    var revealItems = document.querySelectorAll('.parity-reveal-item');
    var parallaxItems = document.querySelectorAll('.parity-parallax-item');
    var scrollCards = document.querySelectorAll('.parity-scroll-card');
    var animateOnScrollItems = document.querySelectorAll('.parity-animate-on-scroll:not(.parity-anim-scale):not(.parity-anim-clip-reveal):not(.parity-anim-clip-reveal-down):not(.parity-anim-line-reveal)');
    var scrollScaleItems = document.querySelectorAll('.parity-anim-scale');
    var clipRevealItems = document.querySelectorAll('.parity-anim-clip-reveal');
    var clipRevealDownItems = document.querySelectorAll('.parity-anim-clip-reveal-down');
    var lineRevealItems = document.querySelectorAll('.parity-anim-line-reveal');
    var blurTargets = document.querySelectorAll('.js-blur-on-scroll');
    var pinTargets = document.querySelectorAll('[data-parity-pin]');

    // ═══════════════════════════════════════════════════════════════
    // PHASE 1 — Immediate: IntersectionObserver-based one-shot animations
    // These never touch the rAF loop. Safe to run on DOMContentLoaded.
    // ═══════════════════════════════════════════════════════════════

    // 1. Intersection Observer for 'Once-on-appear' Reveal Animations (blur, reveal)
    if (animateOnScrollItems.length > 0) {
      var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0
      });

      animateOnScrollItems.forEach(function (item) {
        observer.observe(item);
      });
    }

    // 2. Line Reveal — wrap each inner block element (p, h2, li…) in a clip container
    //    This preserves ALL HTML structure — no text node splitting, no innerHTML replace.
    lineRevealItems.forEach(function (item) {
      if (item.dataset.lineRevealDone) return;
      item.dataset.lineRevealDone = 'true';
      // Outer element is naturally visible; inner .parity-line-reveal-line elements
      // are hidden by translateY(105%) inside overflow:hidden wrappers.

      // Only target DIRECT CHILDREN of the item — never go deeper.
      // Deep querySelectorAll triggers rte-formatter (custom element) mutation
      // callbacks when nested children are moved, causing theme-wide style resets.
      var targets = Array.from(item.children).filter(function (c) {
        return c.textContent.trim() && !c.classList.contains('parity-line-reveal-wrapper');
      });

      // Last-resort fallback: wrap the item's full content as a single line
      if (targets.length === 0) {
        var frag = document.createDocumentFragment();
        while (item.firstChild) frag.appendChild(item.firstChild);
        var lineEl = document.createElement('span');
        lineEl.className = 'parity-line-reveal-line';
        lineEl.appendChild(frag);
        var wrapper = document.createElement('span');
        wrapper.className = 'parity-line-reveal-wrapper';
        wrapper.appendChild(lineEl);
        item.appendChild(wrapper);
        return;
      }

      // Wrap contents of each target element IN-PLACE — preserving outer tags!
      targets.forEach(function (el, i) {
        var wrapper = document.createElement('span');
        wrapper.className = 'parity-line-reveal-wrapper';

        var lineEl = document.createElement('span');
        lineEl.className = 'parity-line-reveal-line';
        lineEl.style.transitionDelay = (i * 0.14).toFixed(2) + 's';

        // Move the children (text, etc) of the target into our line container
        while (el.firstChild) {
          lineEl.appendChild(el.firstChild);
        }
        wrapper.appendChild(lineEl);
        el.appendChild(wrapper); // Appends back into the ORIGINAL element
      });
    });

    // Intersection Observer for line-reveal (one-shot, stagger via CSS transition-delay)
    if (lineRevealItems.length > 0) {
      var lineObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.parity-line-reveal-line').forEach(function (line) {
              line.classList.add('is-visible');
            });
            obs.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0
      });
      lineRevealItems.forEach(function (item) { lineObserver.observe(item); });
    }

    // Wrap clip-reveal items' contents in their clip container (structure only — animation is scroll-driven in Phase 2)
    clipRevealItems.forEach(function (item) {
      if (item.querySelector('.parity-clip-reveal-wrapper')) return;
      var wrapper = document.createElement('span');
      wrapper.className = 'parity-clip-reveal-wrapper';
      var inner = document.createElement('span');
      inner.className = 'parity-clip-reveal-inner';
      while (item.firstChild) inner.appendChild(item.firstChild);
      wrapper.appendChild(inner);
      item.appendChild(wrapper);
    });

    clipRevealDownItems.forEach(function (item) {
      if (item.querySelector('.parity-clip-reveal-wrapper')) return;
      var wrapper = document.createElement('span');
      wrapper.className = 'parity-clip-reveal-wrapper';
      var inner = document.createElement('span');
      inner.className = 'parity-clip-reveal-inner';
      while (item.firstChild) inner.appendChild(item.firstChild);
      wrapper.appendChild(inner);
      item.appendChild(wrapper);
    });

    // ═══════════════════════════════════════════════════════════════
    // PHASE 2 — Deferred: Scroll-driven continuous animations
    // Deferred until first scroll or browser idle to keep the main
    // thread clear during the LCP / TBT measurement window.
    // ═══════════════════════════════════════════════════════════════

    var hasScrollWork =
      revealItems.length > 0 || parallaxItems.length > 0 ||
      scrollCards.length > 0 || scrollScaleItems.length > 0 ||
      clipRevealItems.length > 0 || clipRevealDownItems.length > 0 ||
      blurTargets.length > 0 || pinTargets.length > 0;

    if (!hasScrollWork) return;

    // ── Pin calculation (unchanged logic) ──
    var pinsData = [];
    function calculatePins() {
      if (!pinTargets.length) return;

      var sectionsToPad = new Set();

      // First pass: measure everything without transforms
      pinsData = Array.from(pinTargets).map(function (el) {
        var origTransform = el.style.transform;
        el.style.transform = 'none';

        var rect = el.getBoundingClientRect();
        var absoluteTop = rect.top + window.scrollY;

        var offsetVh = parseFloat(el.getAttribute('data-parity-pin')) || 0;
        var offsetPx = (offsetVh / 100) * window.innerHeight;
        var rotation = el.getAttribute('data-rotation') || '0';

        var section = el.closest('.section-wrapper') || el.parentElement;
        if (section) sectionsToPad.add(section);

        el.style.transform = origTransform;
        return { el: el, absoluteTop: absoluteTop, offsetPx: offsetPx, rotation: rotation, rectHeight: rect.height, section: section };
      });

      // Add a modest pin spacer padding (e.g. 75vh) so the final card stays pinned
      // briefly before the next section scrolls up to push the deck away.
      sectionsToPad.forEach(function (section) {
        section.style.paddingBottom = (window.innerHeight * 0.75) + 'px';
      });

      // Second pass: Calculate maxScrollDistance based on native section height
      pinsData.forEach(function (pin) {
        pin.maxScrollDistance = 0;
        if (pin.section) {
          var sectionBottom = pin.section.getBoundingClientRect().bottom + window.scrollY;
          pin.maxScrollDistance = sectionBottom - pin.absoluteTop - pin.rectHeight;
        }
      });
    }

    // ── Core update with batched reads/writes (Opt D) and off-screen culling (Opt A) ──
    //
    // Original: forEach(item => { read rect → write style }) per group
    //   → interleaved reads/writes cause forced reflow between every element
    //
    // Optimized: collect ALL geometry reads first, then apply ALL style writes.
    //   → single reflow at the read→write boundary, plus off-screen elements skipped entirely.

    function runUpdate() {
      var scrollY = window.scrollY;
      var vh = window.innerHeight;
      // Cull margin: skip elements more than 1 viewport above/below the visible area.
      // Even at aggressive scroll speeds the browser cannot traverse >~100px per frame,
      // so a full-viewport buffer eliminates any risk of visual pop-in.
      // (Intentionally wider than initAboveFold's [0, vh] — this is a scroll-ahead buffer.)
      var cullTop = -vh;
      var cullBottom = vh + vh;

      // ── READ PHASE: Collect all geometry before any style writes ──

      var visibleReveals = [];
      for (var ri = 0; ri < revealItems.length; ri++) {
        var rect = revealItems[ri].getBoundingClientRect();
        if (rect.bottom < cullTop || rect.top > cullBottom) continue;
        visibleReveals.push({ el: revealItems[ri], top: rect.top });
      }

      var visibleParallax = [];
      for (var pi = 0; pi < parallaxItems.length; pi++) {
        var pItem = parallaxItems[pi];
        var parent = pItem.parentElement || pItem;
        var pRect = parent.getBoundingClientRect();
        if (pRect.bottom < cullTop || pRect.top > cullBottom) continue;
        visibleParallax.push({
          el: pItem,
          centerY: pRect.top + (pRect.height / 2),
          speedY: parseFloat(pItem.dataset.parallaxSpeed || 0),
          speedX: parseFloat(pItem.dataset.parallaxSpeedX || 0),
          rotation: pItem.style.getPropertyValue('--atb-rotation') || '0deg'
        });
      }

      var visibleScrollCards = [];
      for (var sci = 0; sci < scrollCards.length; sci++) {
        var scRect = scrollCards[sci].parentElement.getBoundingClientRect();
        if (scRect.bottom < cullTop || scRect.top > cullBottom) continue;
        visibleScrollCards.push({ el: scrollCards[sci], parentTop: scRect.top });
      }

      var visibleScaleItems = [];
      for (var ssi = 0; ssi < scrollScaleItems.length; ssi++) {
        var ssRect = scrollScaleItems[ssi].getBoundingClientRect();
        if (ssRect.bottom < cullTop || ssRect.top > cullBottom) continue;
        visibleScaleItems.push({ el: scrollScaleItems[ssi], top: ssRect.top });
      }

      var visibleClipReveals = [];
      for (var cri = 0; cri < clipRevealItems.length; cri++) {
        var crRect = clipRevealItems[cri].getBoundingClientRect();
        if (crRect.bottom < cullTop || crRect.top > cullBottom) continue;
        visibleClipReveals.push({ el: clipRevealItems[cri], top: crRect.top, idx: cri });
      }

      var visibleClipDownReveals = [];
      for (var cdi = 0; cdi < clipRevealDownItems.length; cdi++) {
        var cdRect = clipRevealDownItems[cdi].getBoundingClientRect();
        if (cdRect.bottom < cullTop || cdRect.top > cullBottom) continue;
        visibleClipDownReveals.push({ el: clipRevealDownItems[cdi], top: cdRect.top, idx: cdi });
      }

      var visibleBlurTargets = [];
      for (var bi = 0; bi < blurTargets.length; bi++) {
        var bSection = blurTargets[bi].closest('.section-wrapper') || blurTargets[bi].parentElement;
        if (!bSection) continue;
        var bRect = bSection.getBoundingClientRect();
        if (bRect.bottom < cullTop || bRect.top > cullBottom) continue;
        visibleBlurTargets.push({ el: blurTargets[bi], sectionTop: bRect.top });
      }

      // ── WRITE PHASE: Apply styles using cached geometry — no forced reflows ──

      // Update Reveal Items (Karaoke mask wipe)
      var revealStart = vh * 0.30;
      var revealEnd = vh * 0.01;
      for (var wri = 0; wri < visibleReveals.length; wri++) {
        var wr = visibleReveals[wri];
        if (wr.top <= revealStart && wr.top >= revealEnd) {
          var progress = (revealStart - wr.top) / (revealStart - revealEnd);
          wr.el.style.setProperty('--wipe-progress', (progress * 100).toFixed(1) + '%');
        } else if (wr.top < revealEnd) {
          wr.el.style.setProperty('--wipe-progress', '100%');
        } else {
          wr.el.style.setProperty('--wipe-progress', '0%');
        }
      }

      // Update Parallax Items
      var viewportCenter = vh / 2;
      for (var wpi = 0; wpi < visibleParallax.length; wpi++) {
        var vp = visibleParallax[wpi];
        if (vp.speedY === 0 && vp.speedX === 0) {
          vp.el.style.transform = 'rotate(' + vp.rotation + ')';
          continue;
        }
        var distanceFromCenter = viewportCenter - vp.centerY;
        var yOffset = distanceFromCenter * (vp.speedY * 0.05);
        var xOffset = distanceFromCenter * (vp.speedX * 0.05);
        vp.el.style.transform = 'translate(' + xOffset + 'px, ' + yOffset + 'px) rotate(' + vp.rotation + ')';
      }

      // Update Scroll Cards
      var cardStart = vh * 0.9;
      var cardEnd = vh * 0.4;
      for (var wsci = 0; wsci < visibleScrollCards.length; wsci++) {
        var vsc = visibleScrollCards[wsci];
        var cardProgress = 0;
        if (vsc.parentTop <= cardStart && vsc.parentTop >= cardEnd) {
          cardProgress = (cardStart - vsc.parentTop) / (cardStart - cardEnd);
        } else if (vsc.parentTop < cardEnd) {
          cardProgress = 1;
        }
        var startRot = parseFloat(vsc.el.dataset.startRotation || -8);
        var yTravel = parseFloat(vsc.el.dataset.yTravel || 200);
        vsc.el.style.setProperty('--card-rotation', startRot * (1 - cardProgress));
        vsc.el.style.setProperty('--card-y', -yTravel * (1 - cardProgress));
      }

      // Scroll-driven Scale Up (0.25 → 1 tied to scroll)
      var scaleStart = vh * 0.85;
      var scaleEnd = vh * 0.20;
      for (var wssi = 0; wssi < visibleScaleItems.length; wssi++) {
        var vs = visibleScaleItems[wssi];
        var scaleProgress = 0;
        if (vs.top <= scaleStart && vs.top >= scaleEnd) {
          scaleProgress = (scaleStart - vs.top) / (scaleStart - scaleEnd);
        } else if (vs.top < scaleEnd) {
          scaleProgress = 1;
        }
        var currentScale = 0.25 + (0.75 * scaleProgress);
        var currentOpacity = Math.min(1, scaleProgress * 2);
        vs.el.style.transform = 'scale(' + currentScale.toFixed(4) + ')';
        vs.el.style.opacity = currentOpacity.toFixed(4);
        vs.el.style.visibility = 'visible';
      }

      // Clip-Path Reveal — scroll-drives translateY from 110% to 0%
      for (var wcri = 0; wcri < visibleClipReveals.length; wcri++) {
        var vcr = visibleClipReveals[wcri];
        var crStaggerOffset = vcr.idx * (vh * 0.03);
        var crStartPoint = (vh * 0.85) - crStaggerOffset;
        var crEndPoint = (vh * 0.30) - crStaggerOffset;
        var crProgress = 0;
        if (vcr.top <= crStartPoint && vcr.top >= crEndPoint) {
          crProgress = (crStartPoint - vcr.top) / (crStartPoint - crEndPoint);
        } else if (vcr.top < crEndPoint) {
          crProgress = 1;
        }
        var crInner = vcr.el.querySelector('.parity-clip-reveal-inner');
        if (crInner) crInner.style.transform = 'translateY(' + (110 * (1 - crProgress)).toFixed(2) + '%)';
      }

      // Clip-Path Reveal Down — scroll-drives translateY from -110% to 0% (falls from above)
      for (var wcdi = 0; wcdi < visibleClipDownReveals.length; wcdi++) {
        var vcd = visibleClipDownReveals[wcdi];
        var cdStaggerOffset = vcd.idx * (vh * 0.03);
        var cdStartPoint = (vh * 0.85) - cdStaggerOffset;
        var cdEndPoint = (vh * 0.30) - cdStaggerOffset;
        var cdProgress = 0;
        if (vcd.top <= cdStartPoint && vcd.top >= cdEndPoint) {
          cdProgress = (cdStartPoint - vcd.top) / (cdStartPoint - cdEndPoint);
        } else if (vcd.top < cdEndPoint) {
          cdProgress = 1;
        }
        var cdInner = vcd.el.querySelector('.parity-clip-reveal-inner');
        if (cdInner) cdInner.style.transform = 'translateY(' + (-110 * (1 - cdProgress)).toFixed(2) + '%)';
      }

      // Progressive Blur on Scroll
      for (var wbi = 0; wbi < visibleBlurTargets.length; wbi++) {
        var vb = visibleBlurTargets[wbi];
        var blurAmount = 0;
        var opacityAmount = 1;
        if (vb.sectionTop < 0) {
          var blurProgress = Math.abs(vb.sectionTop) / (vh / 1.5);
          blurProgress = Math.min(1, blurProgress);
          blurAmount = blurProgress * 15;
          opacityAmount = 1 - (blurProgress * 0.6);
        }
        vb.el.style.filter = 'blur(' + blurAmount.toFixed(1) + 'px)';
        vb.el.style.opacity = opacityAmount.toFixed(2);
      }

      // High-Performance Javascript Pinning & Entrance Animation
      // Pins use pre-calculated absoluteTop values — no getBoundingClientRect in the hot loop.
      if (pinsData.length > 0) {
        for (var wpi2 = 0; wpi2 < pinsData.length; wpi2++) {
          var pin = pinsData[wpi2];
          var triggerY = pin.absoluteTop - pin.offsetPx;
          var startAnimScroll = pin.absoluteTop - vh;

          if (scrollY >= triggerY) {
            // ELEMENT IS PINNED
            var translateAmount = scrollY - triggerY;
            if (pin.maxScrollDistance > 0 && translateAmount > pin.maxScrollDistance) {
              translateAmount = pin.maxScrollDistance;
            }
            pin.el.style.transform = 'translateY(' + translateAmount.toFixed(2) + 'px) rotate(' + pin.rotation + 'deg) scale(1)';
          } else {
            // ELEMENT IS SCROLLING INTO VIEW (Entrance Animation)
            var p = 0;
            if (scrollY > startAnimScroll) {
              p = (scrollY - startAnimScroll) / (triggerY - startAnimScroll);
              p = Math.max(0, Math.min(1, p));
            }
            var easeOut = 1 - Math.pow(1 - p, 3);

            if (pin.el.classList.contains('stacked-card-block')) {
              var pinScale = 1.25 - (0.25 * easeOut);
              var targetRotation = parseFloat(pin.rotation) || 0;
              var currentRotate = 20 - ((20 - targetRotation) * easeOut);
              var currentTranslateYPct = 15 - (15 * easeOut);
              pin.el.style.transform = 'translateY(' + currentTranslateYPct.toFixed(2) + '%) rotate(' + currentRotate.toFixed(2) + 'deg) scale(' + pinScale.toFixed(3) + ')';
            } else {
              pin.el.style.transform = 'translateY(0px) rotate(' + pin.rotation + 'deg)';
            }
          }
        }
      }
    }

    // ── Scroll engine: manages rAF loop lifecycle ──
    function startScrollEngine() {
      calculatePins();

      // Set initial states at current scroll position (single pass, no rAF loop).
      runUpdate();

      var rAF = null;
      var idleTimer = null;

      function loop() {
        runUpdate();
        rAF = requestAnimationFrame(loop);
      }

      window.addEventListener('scroll', function () {
        // Start rAF loop if not already running
        if (!rAF) {
          rAF = requestAnimationFrame(loop);
        }
        // Stop after 100ms of no scrolling to save battery
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function () {
          if (rAF) {
            cancelAnimationFrame(rAF);
            rAF = null;
          }
        }, 100);
      }, { passive: true });

      window.addEventListener('resize', calculatePins, { passive: true });
    }

    // ── Above-fold initializer: set correct initial states without starting the rAF loop ──
    // Runs a single synchronous pass over only the elements in the first viewport.
    // Cost: one getBoundingClientRect + one style write per visible element. No loop.
    function initAboveFold() {
      var vh = window.innerHeight;
      var scrollY = window.scrollY;
      var viewportCenter = vh / 2;

      // Parallax: set initial offsets so accent images aren't at (0,0)
      for (var i = 0; i < parallaxItems.length; i++) {
        var item = parallaxItems[i];
        var parent = item.parentElement || item;
        var rect = parent.getBoundingClientRect();
        // Intentionally tighter than runUpdate's ±1vh cull (line ~200): we only need
        // elements visible at scrollY:0, not the scroll-ahead buffer.
        if (rect.top > vh || rect.bottom < 0) continue;
        var speedY = parseFloat(item.dataset.parallaxSpeed || 0);
        var speedX = parseFloat(item.dataset.parallaxSpeedX || 0);
        var rotation = item.style.getPropertyValue('--atb-rotation') || '0deg';
        if (speedY === 0 && speedX === 0) {
          item.style.transform = 'rotate(' + rotation + ')';
          continue;
        }
        var centerY = rect.top + (rect.height / 2);
        var dist = viewportCenter - centerY;
        item.style.transform = 'translate(' + (dist * speedX * 0.05) + 'px, ' + (dist * speedY * 0.05) + 'px) rotate(' + rotation + ')';
      }

      // Karaoke wipe: set --wipe-progress for above-fold headings
      for (var ri = 0; ri < revealItems.length; ri++) {
        var rRect = revealItems[ri].getBoundingClientRect();
        if (rRect.top > vh || rRect.bottom < 0) continue;
        revealItems[ri].style.setProperty('--wipe-progress', '0%');
      }
    }

    // ── Deferred start (Opt E): keep main thread clear during LCP/TBT window ──
    // In the Shopify theme editor, start immediately for responsive preview.
    if (document.documentElement.classList.contains('shopify-design-mode')) {
      startScrollEngine();
      return;
    }

    // Immediately set above-fold elements to their correct initial state.
    // This is a single synchronous pass — no rAF loop, minimal main-thread cost.
    initAboveFold();

    var engineStarted = false;
    function startOnce() {
      if (engineStarted) return;
      engineStarted = true;
      startScrollEngine();
    }

    // Trigger 1: First user scroll — most common path
    window.addEventListener('scroll', startOnce, { passive: true, once: true });

    // Trigger 2: Browser idle — fallback if user hasn't scrolled.
    // Normalized to 2000ms across both paths so Safari and Chrome behave identically.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(startOnce, { timeout: 2000 });
    } else {
      setTimeout(startOnce, 2000);
    }
  }

  // Run on load and on Shopify Theme Editor events
  document.addEventListener('DOMContentLoaded', initParityAnimations);
  document.addEventListener('shopify:section:load', initParityAnimations);
})();
